export const requiresStrongDeletionConfirmation = deletionSummary => Boolean(
    deletionSummary
    && !deletionSummary.error
    && (
        Number(deletionSummary.rehearsalCount || 0) > 0
        || Number(deletionSummary.upcomingEventCount || 0) > 0
        || Number(deletionSummary.positionCount || 0) > 0
        || deletionSummary.hasNotifications === true
    )
);
